import { useQuery } from '@tanstack/react-query';
import { get } from '../../api/client';

export const PARENTS_LIST_KEYS = {
  PARENTS_LIST: 'PARENTS_LIST',
};

export const useParentsList = ({
  page = 1,
  userIdToSearch,
  userNameToSearch,
}: {
  page?: number;
  userIdToSearch: string;
  userNameToSearch: string;
}) =>
  useQuery(
    [PARENTS_LIST_KEYS.PARENTS_LIST, page, userIdToSearch, userNameToSearch],
    () =>
      get({
        url: 'api/v1/parents/parents-list',
        params: {
          page,
          userName: userNameToSearch,
          userId: userIdToSearch,
        },
      })
  );
